import { useEffect } from 'react';
import testRunsReducer from '../store';
import testRunsSagaWatcher from '../store/sagas';
import { injectSaga } from '@app/store/rootSaga';
import { injectReducer } from '@app/store';

export const useTestrunsChunk = () => {
    useEffect(() => {
        injectReducer('testRuns', testRunsReducer);
        injectSaga('testRuns', testRunsSagaWatcher);
    }, []);
};
